import React, { useState, useEffect } from "react";
import { Trash2, LoaderCircle, Image as ImageIcon } from "lucide-react";
import { COVER_ASPECT } from "../../utils/cover";

const CoverEditor = ({ url, busy, onPick, onRemove, t }) => {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [url]);
  const showCustom = url && !failed;
  return (
    <div
      className="relative rounded-2xl overflow-hidden bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500"
      style={{ aspectRatio: String(COVER_ASPECT), maxHeight: "55vh" }}
    >
      <img
        className={"w-full h-full object-cover " + (showCustom ? "" : "opacity-90")}
        alt={t("Cover")}
        src={showCustom ? url : `${process.env.PUBLIC_URL}/images/coverr.png`}
        onError={() => setFailed(true)}
      />
      <div className="absolute top-2 right-2 flex gap-2">
        <label
          title={t("Change cover")}
          aria-label={t("Change cover")}
          className={
            "inline-flex items-center justify-center gap-1.5 rounded-lg bg-slate-900 hover:bg-black text-white text-xs font-semibold w-9 h-9 sm:w-auto sm:h-auto sm:px-3 sm:py-2 shadow-md transition " +
            (busy ? "opacity-60 pointer-events-none" : "cursor-pointer")
          }
        >
          {busy ? <LoaderCircle className="w-4 h-4 animate-spin" /> : <ImageIcon className="w-4 h-4" />}
          <span className="hidden sm:inline">{busy ? t("Saving...") : t("Change cover")}</span>
          <input
            type="file"
            accept="image/jpeg,image/png,image/webp"
            className="hidden"
            disabled={busy}
            onChange={onPick}
          />
        </label>
        {url && (
          <button
            type="button"
            onClick={onRemove}
            disabled={busy}
            title={t("Remove background")}
            aria-label={t("Remove background")}
            className="inline-flex items-center justify-center gap-1.5 rounded-lg bg-slate-900 hover:bg-red-600 text-white text-xs font-semibold w-9 h-9 sm:w-auto sm:h-auto sm:px-3 sm:py-2 shadow-md transition disabled:opacity-60 disabled:pointer-events-none"
          >
            <Trash2 className="w-4 h-4" />
            <span className="hidden sm:inline">{t("Remove background")}</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default CoverEditor;
